// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media not (min-width:658px){body[data-is-support-mobile-view=true] .G8y3flj92posxDxyNYqc{width:100vw;min-width:100vw}}.G8y3flj92posxDxyNYqc{grid-template-rows:max-content 1fr max-content;width:100%;min-width:366px;height:100%;margin:0 auto;display:grid;position:relative}.pRCGyQxgICHnIqlIEgvM{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%)}.LpjNeiXSZG0McqTed819{height:22px}.c1ovpvXzn0X_04eahyGL{opacity:.5}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `G8y3flj92posxDxyNYqc`,
	"wrapLoader": `pRCGyQxgICHnIqlIEgvM`,
	"footer": `LpjNeiXSZG0McqTed819`,
	"disabled": `c1ovpvXzn0X_04eahyGL`
};
export default ___CSS_LOADER_EXPORT___;
